import { render } from "./kal-page.vue?vue&type=template&id=88069050&scoped=true"
import script from "./kal-page.vue?vue&type=script&lang=js"
export * from "./kal-page.vue?vue&type=script&lang=js"

import "./kal-page.vue?vue&type=style&index=0&id=88069050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88069050"]])

export default __exports__